// extracted by mini-css-extract-plugin
export var messageSideLeft = "_t0-1";
export var stateContainer = "_t0-0";